var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapItinerary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.251,12.174l3.667,1.471c.655.263,1.175.782,1.438,1.438l1.471,3.667c.682,1.7,3.103,1.657,3.724-.066l4.328-12.011c.572-1.587-.963-3.122-2.55-2.55l-12.011,4.328c-1.723.621-1.766,3.042-.066,3.724Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapItinerary);
export default __webpack_public_path__ + "static/media/map-itinerary.4d50b7df5645bc274d6991d8a3f05a24.svg";
export { ForwardRef as ReactComponent };